var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorPlaceOfWorship(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m32.558,13.91c-.713-.634-1.805-.571-2.44.142l-3.003,3.376-5.334-4.746c-.554-.621-1.308-1.073-2.189-1.243h0c-2.128-.411-4.188.977-4.606,3.104l-2.562,13.043c-.243.978.108,2.049.972,2.679l6.333,4.605h-8.758c-1.163,0-2.107.943-2.107,2.107s.943,2.107,2.107,2.107h15.405v-.004c.924.026,1.844-.392,2.425-1.199.927-1.289.639-3.085-.645-4.019l-7.827-5.694,1.875-9.545,3.608,3.21c.63.561,1.595.504,2.156-.126l1.748-1.965-.018-.016,3.003-3.376c.634-.713.571-1.805-.142-2.44Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 6.84,
    r: 3.923
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorPlaceOfWorship);
export default __webpack_public_path__ + "static/media/indoor-place_of_worship.3f17536ad33f640caa511ffc7b23825d.svg";
export { ForwardRef as ReactComponent };